import {
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      static p2p(message) {
        var $this = this.m2r(message);
        captureStack($this, $this.o2p_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static m2r(message) {
        var $this = this.h1o(message);
        captureStack($this, $this.l2r_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
function JsonDecodingException_1(offset, message) {
  return JsonDecodingException().p2p(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  var tmp2 = coerceAtLeast(start_0, 0);
  // Inline function 'kotlin.text.substring' call
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.n2r('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.s2m_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.o2r('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      static v2r(message) {
        var $this = this.m2r(message);
        captureStack($this, $this.u2r_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
function InvalidFloatingPointEncoded(value, output) {
  return JsonEncodingException().v2r('Unexpected special floating-point value ' + toString(value) + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function InvalidKeyKindException(keyDescriptor) {
  return JsonEncodingException().v2r("Value of type '" + keyDescriptor.p1n() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.i1p().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
//region block: exports
export {
  InvalidFloatingPointDecoded as InvalidFloatingPointDecoded2q5szzjempb3,
  InvalidFloatingPointEncoded as InvalidFloatingPointEncoded3n0aum4e9o5qi,
  InvalidKeyKindException as InvalidKeyKindException3b5w96w0jjxof,
  JsonDecodingException_0 as JsonDecodingException1p97qvfqhd5n3,
  JsonDecodingException_1 as JsonDecodingExceptiong65jdof8puc,
  JsonDecodingException as JsonDecodingException278mackfi1uuk,
  JsonEncodingException as JsonEncodingException1thxguokvyir3,
  invalidTrailingComma as invalidTrailingComma2uwwnmbqspks2,
  minify as minify1kh64osmcox7j,
  throwInvalidFloatingPointDecoded as throwInvalidFloatingPointDecoded3ghwdo6vya1kj,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
